import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css';
import { Context } from "../../context";
import { ReactComponent as Close } from '../../svg/close.svg';
const ip = process.env.REACT_APP_IP;

function ModalNouveauPassif({ isOpen, idPerso, setOpen, setModif, passif,token }) {
    const { fetchPersonnage } = useContext(Context);
    const valeur = ["Malus majeur", "Malus", "Neutre", "Bonus", "Bonus Majeur"];
    const [nomPassif, setNomPassif] = useState("");
    const [originePassif, setOriginePassif] = useState("");
    const [valeurPassif, setValeurPassif] = useState(0);
    const [effetPassif, setEffetPassif] = useState("");
    useEffect(() => {

        if (passif) {
            setNomPassif(passif.nom);
            setOriginePassif(passif.origine);
            setValeurPassif(passif.valeur);
            setEffetPassif(passif.effet);
        } else {
            setNomPassif("");
            setOriginePassif("");
            setValeurPassif(0);
            setEffetPassif("");
        }
    }, [passif]);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setModif(false);
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (nomPassif === "" || effetPassif === "" || originePassif === "") {
            console.log("Tous les champs doivent être remplis");
        } else {
            try {
                if (passif) {
                    // Update existing passif
                    await axios.put(`${ip}/passif/${passif.idPassifs}`, {
                        idPerso,
                        nomPassif,
                        originePassif,
                        valeurPassif,
                        effetPassif
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                } else {
                    // Create new passif
                    await axios.post(`${ip}/passif`, {
                        idPerso,
                        nomPassif,
                        originePassif,
                        valeurPassif,
                        effetPassif
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                }
                setNomPassif("");
                setOriginePassif("");
                setValeurPassif(0);
                setEffetPassif("");
                fetchPersonnage();
                setModif(false);
                setOpen(false); // Close the modal
            } catch (error) {
                console.error('Erreur:', error);
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className='modal_flex' ref={wrapperRef}>
                <div className="close" onClick={() => { setOpen(false); setModif(false) }}>
                    <Close></Close>
                </div>
                <span className='titleModal margin_1em_LR pct-90 padding_1em_top'>Nom du passif</span>
                <input
                    type="text"
                    value={nomPassif}
                    onChange={e => setNomPassif(e.target.value)}
                    placeholder="Nom du passif"
                    className='titleModal modal_bloc pct-90 input-transparent'
                />
                <div> </div>
                <span className='titleModal margin_1em_LR pct-90'>Origine du passif</span>
                <textarea
                    type="text"
                    value={originePassif}
                    onChange={e => setOriginePassif(e.target.value)}
                    placeholder="Origine du passif"
                    className='modal-corp pct-90 modal_bloc height_10vh input-transparent'
                />
                <span className='titleModal margin_1em_LR pct-90'>Effet du passif</span>
                <textarea
                    type="text"
                    value={effetPassif}
                    onChange={e => setEffetPassif(e.target.value)}
                    placeholder="Effet du passif"
                    className='pct-90 modal_bloc height_10vh input-transparent'
                />
                <div> </div>
                <span className='titleModal margin_1em_LR pct-90'>Qualité du passif</span>
                <select className="modal_bloc pct-90 input-transparent"
                    value={valeur[valeurPassif + 2]}
                    onChange={e => { setValeurPassif(valeur.indexOf(e.target.value) - 2) }}
                >
                    {valeur.map((element, index) => (
                        <option id={index} key={index} value={element}>{element}</option>
                    ))}
                </select>
                <button onClick={handleSubmit} className='pct-90 modal_bloc button-large'>Enregistrer</button>
            </div>
        </div>
    );
}

export default ModalNouveauPassif;
